// ── Inventory Management Types ───────────────────────────────────────────────

export type InventoryTransactionType =
  | 'order_deduction'
  | 'order_cancellation'
  | 'manual_adjustment'
  | 'restock'
  | 'bulk_update';

export type InventoryStockStatus = 'in_stock' | 'low_stock' | 'out_of_stock' | 'unlimited';

// ── Inventory Item (joined with menu item data for display) ─────────────────

export interface InventoryItem {
  menuItemId: string;
  itemName: string;
  categoryName: string | null;
  menuName: string | null;
  price: number;
  stockQuantity: number;
  lowStockThreshold: number;
  isUnlimitedStock: boolean;
  availabilityStatus: string;
  isAvailable: boolean;
  mediaUrl: string | null;
}

// ── Inventory Transaction (audit log) ───────────────────────────────────────

export interface InventoryTransaction {
  id: string;
  restaurant_id: string;
  menu_item_id: string;
  transaction_type: InventoryTransactionType;
  quantity_change: number;
  stock_after: number;
  order_id: string | null;
  performed_by: string | null;
  reason: string | null;
  created_at: string;
}

// ── API Request/Response Types ──────────────────────────────────────────────

export interface UpdateStockParams {
  stockQuantity: number;
  lowStockThreshold?: number;
  isUnlimitedStock?: boolean;
  reason?: string;
}

export interface BulkUpdateStockItem {
  menuItemId: string;
  stockQuantity: number;
  lowStockThreshold?: number;
  isUnlimitedStock?: boolean;
}

// ── Stock Deduction Result (from RPC) ───────────────────────────────────────

export interface StockDeductionResult {
  new_stock: number;
  was_successful: boolean;
}

// ── Helper: derive display status from stock data ───────────────────────────

export function getStockStatus(item: {
  isUnlimitedStock: boolean;
  stockQuantity: number;
  lowStockThreshold: number;
  availabilityStatus: string;
}): InventoryStockStatus {
  if (item.isUnlimitedStock) return 'unlimited';
  if (item.stockQuantity <= 0 || item.availabilityStatus === 'sold_out') return 'out_of_stock';
  if (item.stockQuantity <= item.lowStockThreshold) return 'low_stock';
  return 'in_stock';
}
